import React from "react";
import styled from "styled-components";
import SkeletonItem from "./../../atoms/SkeletonItem";

const Wrap = styled.div`
    display: flex;
    flex-wrap: wrap;

    @media (min-width: 990px) {

    }
`;

function SkeletonLoader() {
    return (
        <Wrap>
            <SkeletonItem/>
            <SkeletonItem/>
            <SkeletonItem/>
        </Wrap>
    );
}

export default SkeletonLoader;
